// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Main Container */
.notifications-container {
  padding: 0;
  background: linear-gradient(135deg, #f1ede2 0%, #e3ddcd 100%);
  min-height: 100vh;
  font-family:
    "Inter",
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    sans-serif;
}

/* Hero Banner */
.notifications-hero-banner {
  background: linear-gradient(135deg, #101f38 0%, #0a1628 100%);
  color: white;
  padding: 40px 30px;
  box-shadow: 0 20px 50px rgba(16, 31, 56, 0.15);
}

.notifications-hero-banner .hero-content {
  margin-bottom: 30px;
}

.notifications-hero-banner .hero-badge {
  display: inline-block;
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
  padding: 8px 16px;
  border-radius: 50px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  margin-bottom: 12px;
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.notifications-hero-banner h1 {
  margin: 0 0 10px 0;
  font-size: 36px;
  font-weight: 800;
  letter-spacing: -0.8px;
}

.notifications-hero-banner .hero-content p {
  margin: 0;
  font-size: 16px;
  opacity: 0.95;
  max-width: 600px;
}

.hero-stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 16px;
}

.hero-stat {
  display: flex;
  align-items: center;
  gap: 16px;
  background: rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(10px);
  padding: 16px 20px;
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.15);
  transition: all 0.3s ease;
}

.hero-stat:hover {
  background: rgba(255, 255, 255, 0.12);
  transform: translateY(-2px);
}

.stat-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.stat-icon.notifications-total {
  background: rgba(198, 161, 91, 0.2);
  color: #c6a15b;
}

.stat-icon.notifications-scheduled {
  background: rgba(47, 111, 94, 0.2);
  color: #3d8a76;
}

.stat-info {
  display: flex;
  flex-direction: column;
}

.stat-label {
  font-size: 12px;
  opacity: 0.85;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.stat-value {
  font-size: 28px;
  font-weight: 800;
}

/* Header */
.notifications-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 0;
  padding: 30px;
}

.notifications-header .header-content h2 {
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  color: #0a1628;
  letter-spacing: -0.4px;
}

.notifications-header .header-subtitle {
  margin: 8px 0 0 0;
  color: #48546b;
  font-size: 14px;
}

.btn-create-notification {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 24px;
  background: linear-gradient(135deg, #101f38 0%, #132b4d 100%);
  color: white;
  border: none;
  border-radius: 10px;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 8px 24px rgba(16, 31, 56, 0.25);
}

.btn-create-notification:hover {
  background: linear-gradient(135deg, #132b4d 0%, #245349 100%);
  box-shadow: 0 12px 32px rgba(16, 31, 56, 0.35);
  transform: translateY(-2px);
}

/* Form Card */
.notification-form-card {
  background: white;
  padding: 28px;
  border-radius: 16px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  margin: 0 30px 30px 30px;
  animation: slideDown 0.3s ease;
  border: 1px solid rgba(16, 31, 56, 0.08);
}

.notification-form-card h3 {
  margin: 0 0 20px 0;
  font-size: 20px;
  font-weight: 800;
  color: #0a1628;
  background: linear-gradient(135deg, #101f38 0%, #132b4d 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-15px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Alerts */
.notifications-container .alert-success,
.notifications-container .alert-error {
  padding: 14px 16px;
  border-radius: 10px;
  margin-bottom: 15px;
  font-size: 14px;
  font-weight: 600;
  border-left: 4px solid;
}

.notifications-container .alert-success {
  background: #e3efe9;
  color: #245349;
  border-left-color: #3d8a76;
}

.notifications-container .alert-error {
  background: #fbeae5;
  color: #8a3322;
  border-left-color: #c9563a;
}

/* Form */
.notification-form {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.notification-form .form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 18px;
}

.notification-form .form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.notification-form .form-group label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 600;
  color: #0a1628;
  font-size: 14px;
}

.notification-form .form-group input,
.notification-form .form-group select,
.notification-form .form-group textarea {
  padding: 10px 14px;
  border: 1px solid #e3ddcd;
  border-radius: 6px;
  font-size: 14px;
  font-family: inherit;
  background: white;
  transition: all 0.3s ease;
}

.notification-form .form-group input:focus,
.notification-form .form-group select:focus,
.notification-form .form-group textarea:focus {
  outline: none;
  border-color: #2f6f5e;
  box-shadow: 0 0 0 3px rgba(47, 111, 94, 0.1);
}

.notification-form .form-group textarea {
  resize: vertical;
  min-height: 90px;
}

.field-hint {
  font-size: 12px;
  color: #8792a6;
}

/* Chapter multi-select */
.chapter-select-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.chapter-select-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: #8792a6;
}

.chapter-select-actions button {
  background: none;
  border: none;
  color: #2f6f5e;
  font-weight: 700;
  font-size: 12px;
  cursor: pointer;
  padding: 0;
}

.chapter-select-actions button:hover {
  text-decoration: underline;
}

.chapter-checkbox-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding: 14px;
  background: #faf8f2;
  border: 1px solid #e3ddcd;
  border-radius: 10px;
  max-height: 220px;
  overflow-y: auto;
}

.chapter-checkbox {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: white;
  border: 1px solid #e3ddcd;
  border-radius: 20px;
  font-size: 13px;
  color: #0a1628;
  cursor: pointer;
  font-weight: 600;
}

.chapter-checkbox input {
  accent-color: #2f6f5e;
  cursor: pointer;
}

.chapter-empty {
  margin: 0;
  font-size: 13px;
  color: #8792a6;
}

/* Form Actions */
.notification-form .form-actions {
  display: flex;
  gap: 12px;
  margin-top: 10px;
}

.btn-submit,
.btn-cancel {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-submit {
  background: #2f6f5e;
  color: white;
  flex: 1 1;
  justify-content: center;
}

.btn-submit:hover:not(:disabled) {
  background: #245349;
  transform: translateY(-1px);
}

.btn-submit:disabled {
  background: #d8cfb8;
  cursor: not-allowed;
  opacity: 0.7;
}

.btn-cancel {
  background: #f1ede2;
  color: #48546b;
  flex: 1 1;
  justify-content: center;
}

.btn-cancel:hover {
  background: #e3ddcd;
}

/* Loading / Empty States */
.notifications-container .loading-container,
.notifications-container .empty-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 20px;
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
  min-height: 300px;
  margin: 0 30px 30px 30px;
  border: 1px solid rgba(0, 0, 0, 0.04);
}

.notifications-container .spinner {
  animation: spin 1s linear infinite;
  color: #101f38;
  margin-bottom: 15px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.notifications-container .loading-container p {
  color: #48546b;
  font-size: 14px;
}

.notifications-container .empty-container svg {
  color: #d8cfb8;
  margin-bottom: 15px;
}

.notifications-container .empty-container h3 {
  margin: 0 0 8px 0;
  font-size: 18px;
  color: #0a1628;
}

.notifications-container .empty-container p {
  margin: 0;
  color: #8792a6;
  font-size: 14px;
  text-align: center;
  max-width: 320px;
}

/* Notifications List */
.notifications-list {
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 0 30px 30px 30px;
}

.notification-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  background: white;
  border-radius: 14px;
  padding: 18px 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
  border: 1px solid rgba(0, 0, 0, 0.04);
  transition: all 0.25s ease;
}

.notification-row:hover {
  box-shadow: 0 10px 26px rgba(16, 31, 56, 0.1);
  transform: translateY(-2px);
}

.notification-row-main {
  flex: 1 1;
  min-width: 0;
}

.notification-row-top {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 6px;
}

.notification-row-top h4 {
  margin: 0;
  font-size: 16px;
  font-weight: 800;
  color: #0a1628;
}

.status-badge {
  padding: 3px 10px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.badge-sent {
  background: rgba(47, 111, 94, 0.15);
  color: #245349;
}

.badge-scheduled {
  background: rgba(198, 161, 91, 0.2);
  color: #8a6d23;
}

.badge-cancelled {
  background: rgba(201, 86, 58, 0.15);
  color: #8a3322;
}

.notification-row-message {
  margin: 0 0 10px 0;
  font-size: 13px;
  color: #48546b;
  line-height: 1.5;
}

.notification-row-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.notification-row-meta span {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #8792a6;
  font-weight: 600;
}

.btn-cancel-notification {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  border-radius: 8px;
  border: 1px solid #f0c8bb;
  background: #fbeae5;
  color: #8a3322;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.btn-cancel-notification:hover:not(:disabled) {
  background: #f6d9cf;
}

.btn-cancel-notification:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Responsive */
@media (max-width: 768px) {
  .notifications-header {
    flex-direction: column;
    gap: 15px;
    align-items: stretch;
  }

  .btn-create-notification {
    width: 100%;
    justify-content: center;
  }

  .notification-form .form-row {
    grid-template-columns: 1fr;
  }

  .notification-row {
    flex-direction: column;
    align-items: stretch;
  }
}
`, "",{"version":3,"sources":["webpack://./src/admin/components/Notifications.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,UAAU;EACV,6DAA6D;EAC7D,iBAAiB;EACjB;;;;;cAKY;AACd;;AAEA,gBAAgB;AAChB;EACE,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;EACpC,2BAA2B;EAC3B,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qCAAqC;EACrC,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;EACnB,2CAA2C;EAC3C,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,iDAAiD;EACjD,6CAA6C;AAC/C;;AAEA;EACE,6DAA6D;EAC7D,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA,cAAc;AACd;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,wBAAwB;EACxB,8BAA8B;EAC9B,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,WAAW;AACX;;EAEE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,0BAA0B;AAC5B;;AAEA,SAAS;AACT;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;;;EAGE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,SAAO;EACP,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,SAAO;EACP,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,iBAAiB;EACjB,wBAAwB;EACxB,qCAAqC;AACvC;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,0CAA0C;EAC1C,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA;EACE,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;AACF","sourcesContent":["/* Main Container */\r\n.notifications-container {\r\n  padding: 0;\r\n  background: linear-gradient(135deg, #f1ede2 0%, #e3ddcd 100%);\r\n  min-height: 100vh;\r\n  font-family:\r\n    \"Inter\",\r\n    -apple-system,\r\n    BlinkMacSystemFont,\r\n    \"Segoe UI\",\r\n    sans-serif;\r\n}\r\n\r\n/* Hero Banner */\r\n.notifications-hero-banner {\r\n  background: linear-gradient(135deg, #101f38 0%, #0a1628 100%);\r\n  color: white;\r\n  padding: 40px 30px;\r\n  box-shadow: 0 20px 50px rgba(16, 31, 56, 0.15);\r\n}\r\n\r\n.notifications-hero-banner .hero-content {\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.notifications-hero-banner .hero-badge {\r\n  display: inline-block;\r\n  background: rgba(255, 255, 255, 0.2);\r\n  backdrop-filter: blur(10px);\r\n  padding: 8px 16px;\r\n  border-radius: 50px;\r\n  font-size: 12px;\r\n  font-weight: 700;\r\n  letter-spacing: 0.08em;\r\n  text-transform: uppercase;\r\n  margin-bottom: 12px;\r\n  border: 1px solid rgba(255, 255, 255, 0.3);\r\n}\r\n\r\n.notifications-hero-banner h1 {\r\n  margin: 0 0 10px 0;\r\n  font-size: 36px;\r\n  font-weight: 800;\r\n  letter-spacing: -0.8px;\r\n}\r\n\r\n.notifications-hero-banner .hero-content p {\r\n  margin: 0;\r\n  font-size: 16px;\r\n  opacity: 0.95;\r\n  max-width: 600px;\r\n}\r\n\r\n.hero-stats-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\r\n  gap: 16px;\r\n}\r\n\r\n.hero-stat {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 16px;\r\n  background: rgba(255, 255, 255, 0.08);\r\n  backdrop-filter: blur(10px);\r\n  padding: 16px 20px;\r\n  border-radius: 16px;\r\n  border: 1px solid rgba(255, 255, 255, 0.15);\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.hero-stat:hover {\r\n  background: rgba(255, 255, 255, 0.12);\r\n  transform: translateY(-2px);\r\n}\r\n\r\n.stat-icon {\r\n  width: 48px;\r\n  height: 48px;\r\n  border-radius: 12px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.stat-icon.notifications-total {\r\n  background: rgba(198, 161, 91, 0.2);\r\n  color: #c6a15b;\r\n}\r\n\r\n.stat-icon.notifications-scheduled {\r\n  background: rgba(47, 111, 94, 0.2);\r\n  color: #3d8a76;\r\n}\r\n\r\n.stat-info {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.stat-label {\r\n  font-size: 12px;\r\n  opacity: 0.85;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.05em;\r\n}\r\n\r\n.stat-value {\r\n  font-size: 28px;\r\n  font-weight: 800;\r\n}\r\n\r\n/* Header */\r\n.notifications-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: flex-start;\r\n  margin-bottom: 0;\r\n  padding: 30px;\r\n}\r\n\r\n.notifications-header .header-content h2 {\r\n  margin: 0;\r\n  font-size: 24px;\r\n  font-weight: 700;\r\n  color: #0a1628;\r\n  letter-spacing: -0.4px;\r\n}\r\n\r\n.notifications-header .header-subtitle {\r\n  margin: 8px 0 0 0;\r\n  color: #48546b;\r\n  font-size: 14px;\r\n}\r\n\r\n.btn-create-notification {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 12px 24px;\r\n  background: linear-gradient(135deg, #101f38 0%, #132b4d 100%);\r\n  color: white;\r\n  border: none;\r\n  border-radius: 10px;\r\n  font-weight: 700;\r\n  font-size: 14px;\r\n  cursor: pointer;\r\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n  box-shadow: 0 8px 24px rgba(16, 31, 56, 0.25);\r\n}\r\n\r\n.btn-create-notification:hover {\r\n  background: linear-gradient(135deg, #132b4d 0%, #245349 100%);\r\n  box-shadow: 0 12px 32px rgba(16, 31, 56, 0.35);\r\n  transform: translateY(-2px);\r\n}\r\n\r\n/* Form Card */\r\n.notification-form-card {\r\n  background: white;\r\n  padding: 28px;\r\n  border-radius: 16px;\r\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);\r\n  margin: 0 30px 30px 30px;\r\n  animation: slideDown 0.3s ease;\r\n  border: 1px solid rgba(16, 31, 56, 0.08);\r\n}\r\n\r\n.notification-form-card h3 {\r\n  margin: 0 0 20px 0;\r\n  font-size: 20px;\r\n  font-weight: 800;\r\n  color: #0a1628;\r\n  background: linear-gradient(135deg, #101f38 0%, #132b4d 100%);\r\n  -webkit-background-clip: text;\r\n  -webkit-text-fill-color: transparent;\r\n  background-clip: text;\r\n}\r\n\r\n@keyframes slideDown {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(-15px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n/* Alerts */\r\n.notifications-container .alert-success,\r\n.notifications-container .alert-error {\r\n  padding: 14px 16px;\r\n  border-radius: 10px;\r\n  margin-bottom: 15px;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  border-left: 4px solid;\r\n}\r\n\r\n.notifications-container .alert-success {\r\n  background: #e3efe9;\r\n  color: #245349;\r\n  border-left-color: #3d8a76;\r\n}\r\n\r\n.notifications-container .alert-error {\r\n  background: #fbeae5;\r\n  color: #8a3322;\r\n  border-left-color: #c9563a;\r\n}\r\n\r\n/* Form */\r\n.notification-form {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 18px;\r\n}\r\n\r\n.notification-form .form-row {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr;\r\n  gap: 18px;\r\n}\r\n\r\n.notification-form .form-group {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n}\r\n\r\n.notification-form .form-group label {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  font-weight: 600;\r\n  color: #0a1628;\r\n  font-size: 14px;\r\n}\r\n\r\n.notification-form .form-group input,\r\n.notification-form .form-group select,\r\n.notification-form .form-group textarea {\r\n  padding: 10px 14px;\r\n  border: 1px solid #e3ddcd;\r\n  border-radius: 6px;\r\n  font-size: 14px;\r\n  font-family: inherit;\r\n  background: white;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.notification-form .form-group input:focus,\r\n.notification-form .form-group select:focus,\r\n.notification-form .form-group textarea:focus {\r\n  outline: none;\r\n  border-color: #2f6f5e;\r\n  box-shadow: 0 0 0 3px rgba(47, 111, 94, 0.1);\r\n}\r\n\r\n.notification-form .form-group textarea {\r\n  resize: vertical;\r\n  min-height: 90px;\r\n}\r\n\r\n.field-hint {\r\n  font-size: 12px;\r\n  color: #8792a6;\r\n}\r\n\r\n/* Chapter multi-select */\r\n.chapter-select-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.chapter-select-actions {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  font-size: 12px;\r\n  color: #8792a6;\r\n}\r\n\r\n.chapter-select-actions button {\r\n  background: none;\r\n  border: none;\r\n  color: #2f6f5e;\r\n  font-weight: 700;\r\n  font-size: 12px;\r\n  cursor: pointer;\r\n  padding: 0;\r\n}\r\n\r\n.chapter-select-actions button:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n.chapter-checkbox-list {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 10px;\r\n  padding: 14px;\r\n  background: #faf8f2;\r\n  border: 1px solid #e3ddcd;\r\n  border-radius: 10px;\r\n  max-height: 220px;\r\n  overflow-y: auto;\r\n}\r\n\r\n.chapter-checkbox {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: 6px 12px;\r\n  background: white;\r\n  border: 1px solid #e3ddcd;\r\n  border-radius: 20px;\r\n  font-size: 13px;\r\n  color: #0a1628;\r\n  cursor: pointer;\r\n  font-weight: 600;\r\n}\r\n\r\n.chapter-checkbox input {\r\n  accent-color: #2f6f5e;\r\n  cursor: pointer;\r\n}\r\n\r\n.chapter-empty {\r\n  margin: 0;\r\n  font-size: 13px;\r\n  color: #8792a6;\r\n}\r\n\r\n/* Form Actions */\r\n.notification-form .form-actions {\r\n  display: flex;\r\n  gap: 12px;\r\n  margin-top: 10px;\r\n}\r\n\r\n.btn-submit,\r\n.btn-cancel {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 10px 20px;\r\n  border: none;\r\n  border-radius: 6px;\r\n  font-weight: 600;\r\n  font-size: 14px;\r\n  cursor: pointer;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.btn-submit {\r\n  background: #2f6f5e;\r\n  color: white;\r\n  flex: 1;\r\n  justify-content: center;\r\n}\r\n\r\n.btn-submit:hover:not(:disabled) {\r\n  background: #245349;\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.btn-submit:disabled {\r\n  background: #d8cfb8;\r\n  cursor: not-allowed;\r\n  opacity: 0.7;\r\n}\r\n\r\n.btn-cancel {\r\n  background: #f1ede2;\r\n  color: #48546b;\r\n  flex: 1;\r\n  justify-content: center;\r\n}\r\n\r\n.btn-cancel:hover {\r\n  background: #e3ddcd;\r\n}\r\n\r\n/* Loading / Empty States */\r\n.notifications-container .loading-container,\r\n.notifications-container .empty-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 80px 20px;\r\n  background: white;\r\n  border-radius: 16px;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);\r\n  min-height: 300px;\r\n  margin: 0 30px 30px 30px;\r\n  border: 1px solid rgba(0, 0, 0, 0.04);\r\n}\r\n\r\n.notifications-container .spinner {\r\n  animation: spin 1s linear infinite;\r\n  color: #101f38;\r\n  margin-bottom: 15px;\r\n}\r\n\r\n@keyframes spin {\r\n  0% {\r\n    transform: rotate(0deg);\r\n  }\r\n  100% {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n.notifications-container .loading-container p {\r\n  color: #48546b;\r\n  font-size: 14px;\r\n}\r\n\r\n.notifications-container .empty-container svg {\r\n  color: #d8cfb8;\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.notifications-container .empty-container h3 {\r\n  margin: 0 0 8px 0;\r\n  font-size: 18px;\r\n  color: #0a1628;\r\n}\r\n\r\n.notifications-container .empty-container p {\r\n  margin: 0;\r\n  color: #8792a6;\r\n  font-size: 14px;\r\n  text-align: center;\r\n  max-width: 320px;\r\n}\r\n\r\n/* Notifications List */\r\n.notifications-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 14px;\r\n  padding: 0 30px 30px 30px;\r\n}\r\n\r\n.notification-row {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: flex-start;\r\n  gap: 16px;\r\n  background: white;\r\n  border-radius: 14px;\r\n  padding: 18px 20px;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);\r\n  border: 1px solid rgba(0, 0, 0, 0.04);\r\n  transition: all 0.25s ease;\r\n}\r\n\r\n.notification-row:hover {\r\n  box-shadow: 0 10px 26px rgba(16, 31, 56, 0.1);\r\n  transform: translateY(-2px);\r\n}\r\n\r\n.notification-row-main {\r\n  flex: 1;\r\n  min-width: 0;\r\n}\r\n\r\n.notification-row-top {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  margin-bottom: 6px;\r\n}\r\n\r\n.notification-row-top h4 {\r\n  margin: 0;\r\n  font-size: 16px;\r\n  font-weight: 800;\r\n  color: #0a1628;\r\n}\r\n\r\n.status-badge {\r\n  padding: 3px 10px;\r\n  border-radius: 20px;\r\n  font-size: 11px;\r\n  font-weight: 800;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.04em;\r\n}\r\n\r\n.badge-sent {\r\n  background: rgba(47, 111, 94, 0.15);\r\n  color: #245349;\r\n}\r\n\r\n.badge-scheduled {\r\n  background: rgba(198, 161, 91, 0.2);\r\n  color: #8a6d23;\r\n}\r\n\r\n.badge-cancelled {\r\n  background: rgba(201, 86, 58, 0.15);\r\n  color: #8a3322;\r\n}\r\n\r\n.notification-row-message {\r\n  margin: 0 0 10px 0;\r\n  font-size: 13px;\r\n  color: #48546b;\r\n  line-height: 1.5;\r\n}\r\n\r\n.notification-row-meta {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 16px;\r\n}\r\n\r\n.notification-row-meta span {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  font-size: 12px;\r\n  color: #8792a6;\r\n  font-weight: 600;\r\n}\r\n\r\n.btn-cancel-notification {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: 8px 14px;\r\n  border-radius: 8px;\r\n  border: 1px solid #f0c8bb;\r\n  background: #fbeae5;\r\n  color: #8a3322;\r\n  font-size: 12px;\r\n  font-weight: 700;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.btn-cancel-notification:hover:not(:disabled) {\r\n  background: #f6d9cf;\r\n}\r\n\r\n.btn-cancel-notification:disabled {\r\n  opacity: 0.6;\r\n  cursor: not-allowed;\r\n}\r\n\r\n/* Responsive */\r\n@media (max-width: 768px) {\r\n  .notifications-header {\r\n    flex-direction: column;\r\n    gap: 15px;\r\n    align-items: stretch;\r\n  }\r\n\r\n  .btn-create-notification {\r\n    width: 100%;\r\n    justify-content: center;\r\n  }\r\n\r\n  .notification-form .form-row {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .notification-row {\r\n    flex-direction: column;\r\n    align-items: stretch;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
